// utils/reconcile.js
// Pure, form-agnostic check: does the certificate total attached to a return
// match the credits actually claimed on that return? Used today by the 2550Q
// filing card (SAWT/2306 total vs "Less: 2306" claimed); 2551Q/1701Q/1702Q
// filing cards can call this later with their own inputs — nothing here is
// VAT-specific.
//
// Tolerant of sub-centavo float drift from repeated arithmetic (rounds to 2dp
// before comparing) rather than requiring an exact float match.
export const reconcile = ({ creditsClaimed, certificateTotal }) => {
  const claimed = Number(creditsClaimed) || 0;
  const certificates = Number(certificateTotal) || 0;
  const difference = Math.round((certificates - claimed) * 100) / 100;

  return {
    matched: Math.abs(difference) < 0.005,
    difference,
    creditsClaimed: claimed,
    certificateTotal: certificates,
  };
};

export default reconcile;
